import React from 'react';

export default function RecipeList({ recipes, selectedId, onSelect }) {
    if (!recipes || recipes.length === 0) {
        return <div className="recipe-list-empty">No recipes found</div>;
    }

    return (
        <div className="recipe-list">
            {recipes.map(r => (
                <button
                    key={r.id}
                    className={`recipe-list-item ${r.id === selectedId ? 'selected' : ''}`}
                    onClick={() => onSelect(r.id)}
                >
                    {r.name || r.id}
                </button>
            ))}
        </div>
    );
}
